import {
  getSessionClientInformation,
  getSessionUserInformation,
} from "app/utils/utility.service";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { InputSwitch } from "primereact/inputswitch";

import { Button } from "primereact/button";

import {
  getAccounts,
  getCommodities,
  getCommoditiesStats,
  getCrypto,
  getCryptoStats,
  getDepletionDetails,
  getFinancials,
  getFinancialsStats,
  getNetworthProjectionValues,
  getPropertyDetails,
} from "../homepurchase.service";
import { getNetWorthReportRecords } from "app/utils/utility.service";
import NetworthTable from "./NetWorthTable";
import LineChart from "./LineChart";
import moment from "moment";

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const { reportData, showMore, showButton, handleShowMore } = props;

  const baseYear = Number(moment().format("YYYY"));
  //  let chartData = reportData.filter(d => (d.year - baseYear) % 2 === 0);
  const [chartData, setChartData] = useState(
    reportData.filter((d) => (d.year - baseYear) % 2 === 0)
  );
  const [newReportData, setNewReportData] = useState([reportData]);

  const [lastReportData] = useState([reportData[reportData.length - 1]]);
  const [tableView, setTableView] = useState(true);
  const [hidden, setHidden] = useState({ stock: false, commodities: false });
  let updatedChartData = [];

  const hiddenRef = useRef({ stock: false, commodities: false });

  useEffect(() => {
    if (reportData?.length > 0) {
      if (!showButton) {
        if (!showMore) {
          setNewReportData([...reportData.slice(0, 4)]);
        }
        if (showMore) {
          setNewReportData([...reportData]);
        }
      } else {
        setNewReportData([...reportData]);
      }
    }
  }, [showMore, showButton]);

  let labels = chartData.map((d) => d.year);

  const data = chartData;

  return (
    <div ref={ref}>
      <div className="align-text-rt mt-4" style={{ width: "98%" }}>
        <label className="mb-3 mr-3" style={{ fontSize: "1.2rem" }}>
          Table View
        </label>
        <InputSwitch
          style={{ transform: "scale(1.25)", transformOrigin: "left" }}
          checked={tableView}
          onChange={(e) => {
            setTableView(e.value);
            if (e.value) updatedChartData = reportData;
          }}
        ></InputSwitch>
        <label className="mb-3 ml-4" style={{ fontSize: "1.2rem" }}>
          Chart View
        </label>
      </div>

      <div className="Reports ">
        {!tableView ? (
          <Fragment>
            <div className="HomePrice right ml-4 ">
              <div className="printSeparation"></div>

              <NetworthTable
                reportData={chartData}
                showMore={showMore}
                showButton={!showButton}
                handleShowMore={handleShowMore}
                lastData={lastReportData}
                hidden={hidden}
              />
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <LineChart
              chartData={chartData}
              labels={labels}
              originalData={reportData.filter(
                (d) => (d.year - baseYear) % 2 === 0
              )}
              onToggle={(label, ds) => {
                setHidden((prev) => {
                  const next = { ...prev };

                  if (label === "Stock Market") next.stock = !prev.stock;
                  if (label === "Commodities")
                    next.commodities = !prev.commodities;
                  if (label === "Real Estate")
                    next.realEstate = !prev.realEstate;
                  if (label === "Cryptocurrency") next.crypto = !prev.crypto;
                   if (label === "Depletion") next.depletion = !prev.depletion;
                  if (label === "Mortgage") next.mortgage = !prev.mortgage;
                  return next;
                });

                let updatedChartData1 = chartData.map((item, index) => ({
                  ...item,
                  netWorth: ds[index], // overwrite netWorth with new value
                }));
                updatedChartData = updatedChartData1;
                setChartData(updatedChartData1);

              }}
              hidden={hidden}
            ></LineChart>
          </Fragment>
        )}
      </div>

      <div className="printSeparation"></div>
    </div>
  );
});

const NetWorthProjection = () => {
  const [searchParams] = useSearchParams();
  const componentRef = useRef(null);
  const clientId = searchParams.get("clientid");
  const [isLoading, setIsLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  let sessionValues =
    clientId && clientId !== "null"
      ? getSessionClientInformation()
      : getSessionUserInformation();
  const clientInfo = getSessionClientInformation();
  if (clientInfo) {
    sessionValues = clientInfo;
  }

  const [commodities, setCommodities] = useState();
  const [commoditiesList, setCommoditiesList] = useState([]);
  const [crypto, setCrypto] = useState();
  const [portfolioList, setPortfolioList] = useState([]);
  const [depletions, setDepletions] = useState([]);
  const [cryptoList, setCryptoList] = useState([]);
  const [financial, setFinancial] = useState();
  const [financialList, setFinancialList] = useState([]);
  const [mortgage, setMortgage] = useState();
  const [assets, setAssets] = useState();
  const [assetsDetails, setAssetsDetails] = useState([]);
  const [liabilities, setLiabilities] = useState();
  const [realEstate, setRealestate] = useState();
  const navigate = useNavigate();
  const [isPrinting, setIsPrinting] = useState(false);
  const promiseResolveRef = useRef(null);
  const [graphRecords, setGraphRecords] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
      promiseResolveRef.current();
    }
  }, [isPrinting]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        promiseResolveRef.current = resolve;
        setIsPrinting(true);
      });
    },
    onAfterPrint: () => {
      // Reset the Promise resolve so we can print again
      promiseResolveRef.current = null;
      setIsPrinting(false);
    },
  });

  const fetchPortfolioInformation = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
    const fetchedRecord = await getPropertyDetails(userId);
    if (fetchedRecord) {
      setPortfolioList(fetchedRecord);
      setIsLoading(false);
      return;
    }
  };

  const fetchCommoditiesInformation = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
    const fetchedRecord = await getCommodities(userId);
    if (fetchedRecord) {
      setCommoditiesList(fetchedRecord);
      setIsLoading(false);
      return;
    }
  };

  const fetchCryptoInformation = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
    const fetchedRecord = await getCrypto(userId);
    if (fetchedRecord) {
      setCryptoList(fetchedRecord);
      setIsLoading(false);
      return;
    }
  };

  const fetchFinancialsInformation = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
    // const fetchedRecord = await getFinancialsStats(userId);
    let list = await getFinancials(userId);
    if (list) {
      setFinancialList(list);
      setIsLoading(false);
      return;
    }
  };

  
  const fetchDepletionInformation = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
    const fetchedRecord = await getDepletionDetails(userId);
    if (fetchedRecord) {
      setDepletions(fetchedRecord);
      setIsLoading(false);
      return;
    }
  };

  const getAccountDetails = async () => {
    setIsLoading(true);
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
    const fetchedRecords = await getNetworthProjectionValues(userId);
    if (fetchedRecords) {
      setRealestate(fetchedRecords.realEstateTotal);
      setMortgage(fetchedRecords.loanTotal);
      setAssets(fetchedRecords.assetsTotal);
      setAssetsDetails(fetchedRecords.assets);
      setLiabilities(fetchedRecords.liabilities);
      setCommodities(fetchedRecords.comTotal);
      setCrypto(fetchedRecords.cryptoTotal);
      setFinancial(fetchedRecords.stockTotal);
      setIsLoading(false);
      return;
    }
  
  };

  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  const getComponentToPrint = (showButton) => {
    let totalHomeValueElements = [];
    let totalHomeLabelElements = [];
    if (graphRecords?.totalHomeValue?.length > 0) {
      graphRecords?.totalHomeValue.forEach((element, index) => {
        if (index === 0) {
          totalHomeValueElements.push(Number(element).toFixed(0));
        } else {
          if (index % 3 === 0) {
            totalHomeValueElements.push(Number(element).toFixed(0));
          }
        }
      });
      if (graphRecords?.labels?.length > 0) {
        graphRecords?.labels.forEach((element, index) => {
          if (index === 0) {
            totalHomeLabelElements.push(element);
          } else {
            if (index % 3 === 0) {
              totalHomeLabelElements.push(element);
            }
          }
        });
      }
    }
    return (
      <ComponentToPrint
        reportData={graphRecords.reportData}
        labels={totalHomeLabelElements}
        showMore={showMore}
        handleShowMore={handleShowMore}
        showButton={showButton}
        ref={componentRef}
      />
    );
  };

  useEffect(() => {
    Promise.all([
      getAccountDetails(),
      fetchFinancialsInformation(),
      fetchCommoditiesInformation(),
      fetchCryptoInformation(),
      fetchPortfolioInformation(),
      fetchDepletionInformation()
    ]).then(() => {
      setLoading(false); // All API calls finished
    });
  }, []);

  useEffect(() => {
  
    if (!loading) {
      setGraphRecords(
        getNetWorthReportRecords(
          financialList,
          cryptoList,
          commoditiesList,
          assetsDetails,
          assets,
          liabilities,
          portfolioList,
          realEstate,
          financial,
          commodities,
          crypto,
          mortgage,
          depletions
        )
      );
    }
  }, [
    loading,
    commodities,
    crypto,
    financial,
    realEstate,
    assets,
    liabilities,
    portfolioList,
    financialList,
    cryptoList,
    commoditiesList,
  ]);

  return (
    <Fragment>
      {!isLoading && graphRecords?.labels?.length > 0 ? (
        <Fragment>
          {getComponentToPrint(isPrinting)}
          <div style={{ width: "100%", paddingLeft: "69rem" }}>
            <Button
              className="p-button-raised p-button-warning mr-2"
              onClick={handlePrint}
            >
              Print Report
            </Button>
            <Button
              label="Cancel"
              className="p-button-raised p-button"
              onClick={() => navigate(-1)}
            />
          </div>
        </Fragment>
      ) : (
        <p>Please store the data to print the report.</p>
      )}
    </Fragment>
  );
};

export default NetWorthProjection;
